module.exports = __webpack_public_path__ + "static/img/manual-41.3ab07e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-41.png
// module id = w26D
// module chunks = 4